import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const renameViewStmtInstruction = `
#### Rename View
- Syntax: \`rename view <view_name> to <new_veiw_name>;\`
- Example: \`rename view Products to ProductList;\``;
export const stmtRenameView = ({ viewName, newViewName }) => {
    return `rename view ${viewName} to ${newViewName};`;
};
export const renameViewHandler = createStructureStatementHandler({
    type: 'rename view',
    parse: line => {
        const match = /^rename view (?<viewName>\w+) to (?<newViewName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'rename view',
                viewName: match.groups.viewName,
                newViewName: match.groups.newViewName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.renameView(stmt.viewName, stmt.newViewName)),
});
//# sourceMappingURL=RenameViewStmt.js.map